import React, { FC } from 'react'
import { SVGProps } from './types'

export const SocMiniLogo: FC<SVGProps> = ({ size, color, onClick }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 316 295.3"
      width={size}
      height={size}
      onClick={onClick}
    >
      <g>
        <path
          fill={color}
          d="M290.5,20.5C271.7,6,146.7,48.7,60.3,103.7c-28.2,19.6-19.7,18.1,0.2,4.4c71.6-37.8,188.4-84,217.1-70.4
            c28.8,13.6-9.5,89.3-20.6,210.4c-1.2,12.8-4.4,57.5,9.3,2.3C266.3,250.4,308.6,34.5,290.5,20.5z"
        />
        <path
          fill={color}
          d="M169.8,201.4c19.4-19.3,69.2-49.2,102.7-141.2c2.1-5.9-5.1-0.9-5.1-0.9c-60.2,103.2-100.8,133-112.3,142.6
            c-15.5,12.8-25.7,52.8-90-38.9c-1.2-1.4-13.5-10.6-0.3,7.9C136.8,260.9,150.4,220.7,169.8,201.4z"
        />
        <path
          fill={color}
          d="M230.8,272.1C90.7,239.6,78.1,293.1,40.2,259.1c-13-11.4-10.8-25.7-10.8-25.7c0.5-12.9-4.1-4.2-3.3,0.4
            c0,0-0.6,20.6,16.8,33.4c41.2,23.4,21.8-2.5,202.6,12.4C254,279.5,230.8,272.1,230.8,272.1z"
        />
      </g>
    </svg>
  )
}
